import { List, Record } from 'immutable'

export const Attrib = Record({
  orgId: undefined,
  deleted: false,
  createdDateTime: undefined,
  updatedDateTime: undefined,
  label: 'Account Attribute',
  name: 'account_attribute',
  options: List(),
  type: undefined,
  userId: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/models.js